import React, { useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { AssinaturaContext } from "../../contexts/Assinatura/AssinaturaContext";
import { AssinaturaApi } from "../../hooks/assinaturaApi";
import { Fatura } from "../../types/Assinatura";
import { AssinaturaNova } from "./AssinaturaNova/AssinaturaNova";
import { ViewAssinatura } from "./styles";
import SkeletonAssinatura from "../../components/Skeletons/SkeletonAssinatura/SkeletonAssinatura";

/**
 * Container da rota /assinatura.
 *
 * Consome AssinaturaContext (info, fluxoNovo) — sem fetch local. Pra fluxo
 * novo, busca faturas em paralelo. Pra Superlogica (fluxoNovo===false),
 * redireciona pra home (rota só existe pra fluxo novo).
 */
export const Assinatura: React.FC = () => {
  const { theme } = useTheme();
  const { info, fluxoNovo, loading: loadingInfo, refresh } = useContext(AssinaturaContext);
  const [faturas, setFaturas] = useState<Fatura[]>([]);

  const carregarFaturas = useCallback(async () => {
    if (fluxoNovo !== true) return;
    try {
      const dados = await AssinaturaApi().listarFaturas();
      setFaturas(dados.faturas || []);
    } catch (err) {
      console.error("Erro ao carregar faturas:", err);
      setFaturas([]);
    }
  }, [fluxoNovo]);

  useEffect(() => {
    carregarFaturas();
  }, [carregarFaturas]);

  const handleRefresh = useCallback(async () => {
    await refresh();
    await carregarFaturas();
  }, [refresh, carregarFaturas]);

  if (loadingInfo) {
    return <SkeletonAssinatura />;
  }

  if (!info) {
    return (
      <ViewAssinatura theme={theme}>
        <div className="state erro">
          Não foi possível carregar os dados da assinatura. Tente recarregar a página.
        </div>
      </ViewAssinatura>
    );
  }

  if (!info.fluxo_novo) {
    return <Navigate to="/" replace />;
  }

  return (
    <AssinaturaNova info={info} faturas={faturas} onRefresh={handleRefresh} />
  );
};

export default Assinatura;
